import { Link } from 'react-router-dom';
import TooltipWrapper from '../tooltip/TooltipWrapper';
import { Routes } from '@/types';

interface WorkspaceNameProps {
  workspaceName: string;
  workspaceId?: string;
  projectTitle: string;
  organizationId?: string;
  resetTabs: () => void;
  routes: Routes;
}

function WorkspaceName({
  projectTitle,
  workspaceName,
  routes,
  organizationId,
  workspaceId,
  resetTabs,
}: WorkspaceNameProps) {
  return (
    <div className="flex gap-1">
      /
      <TooltipWrapper text="Back to workspace" className="text-xs">
        <Link
          onClick={resetTabs}
          className="transition-all ease-in-out hover:underline"
          to={`${routes.organization.path}/${organizationId}${routes.workspace.path}/${workspaceId}`}
        >
          {workspaceName}
        </Link>
      </TooltipWrapper>
      /<p>{projectTitle}</p>
    </div>
  );
}

export default WorkspaceName;
